<template>
  <div>
    <v-container fluid>
      <div class="main">

        <v-row>
          <v-col cols="12">

            <v-row align="center" class="mb-3">
              <v-col cols="10">
                <v-tabs background-color="transparent">

                  <v-tab @click="[status = 'all', getInvestigations(true)]">
                    <v-icon left dense>mdi-format-list-bulleted</v-icon>
                    Tous
                  </v-tab>

                  <v-tab @click="[status = 'pending', getInvestigations(true)]">
                    <v-icon left dense>mdi-timer-sand</v-icon>
                    En attente
                  </v-tab>

                  <v-tab @click="[status = 'validated', getInvestigations(true)]">
                    <v-icon left dense>mdi-checkbox-marked-circle-outline</v-icon>
                    Validées
                  </v-tab>

                  <v-tab @click="[status = 'refused', getInvestigations(true)]">
                    <v-icon left dense>mdi-close-circle-outline</v-icon>
                    Refusées
                  </v-tab>

                  <v-tab @click="[status = 'reclaimed', getInvestigations(true)]">
                    <v-icon left dense>mdi-alert-circle-outline</v-icon>
                    Réclamées
                  </v-tab>

                </v-tabs>
              </v-col>
              <v-col cols="2" class="text-end">
              </v-col>
            </v-row>

            <v-card class="rounded-lg shadow" :loading="overlay" :disabled="overlay">

              <v-card-title>
                <div>
                  <v-text-field
                      v-model="keyword"
                      append-icon="mdi-magnify"
                      @keydown.enter="getInvestigations"
                      hint="Appuyez sur ↵ Entrée pour rechercher"
                      clearable
                      @click:clear="[keyword=null,getInvestigations()]"
                      dense
                      filled
                      persistent-hint
                      placeholder="Recherche..."
                      rounded
                  ></v-text-field>
                </div>
                <v-spacer/>

                <v-btn color="gifty" text
                       @click="getInvestigations(true)">
                  <v-icon left>mdi-refresh</v-icon>
                  Mettre à jour
                </v-btn>

                <v-btn color="gifty" text @click="handleExport">
                  <v-icon left>mdi-export</v-icon>
                  Exporter
                </v-btn>

                <v-btn color="gifty" text>
                  <v-icon left>mdi-filter-outline</v-icon>
                  Filtrer
                </v-btn>
              </v-card-title>

              <v-divider/>

              <v-card-text v-if="isLoading">
                <v-skeleton-loader type="table"/>
              </v-card-text>

              <div v-else>
                <v-card-text class="pa-0">
                  <v-simple-table v-if="investigations.length">
                    <template v-slot:default>
                      <thead>
                      <tr>
                        <th>Image</th>
                        <th>Statut</th>
                        <th class="text-no-wrap">Nom d'utilisateur</th>
                        <th class="text-no-wrap">Tél. d'utilisateur</th>
                        <th class="text-no-wrap text-center">Total validées</th>
                        <th class="text-no-wrap text-center">Total Points</th>
                        <th class="text-no-wrap">Date de réponse</th>
                        <th class="text-no-wrap">Date de ticket</th>
                        <th class="text-no-wrap">N° de ticket</th>
                        <th class="text-no-wrap">Total de ticket</th>
                        <th>Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item ,index) in investigations" :key="index">


                        <td>
                          <v-img @click="[lightboxImage = [{src: FILE_URL + item.receipt_image}],visible = true]"
                                 class="rounded-lg grey lighten-4 cursor-zoom my-1"
                                 width="50"
                                 height="50"
                                 :src="FILE_URL + item.receipt_image"></v-img>
                        </td>

                        <td>
                          <v-chip small
                                  @click="item.status === 'refused' ? [rejectionReasonDialog = true , rejectionReason = item.rejection_reason] : false"
                                  :text-color="item.status_text['text_color']"
                                  :class="item.status_text['class']"
                                  class="font-weight-medium">
                            <v-icon left small :color="item.status_text['text_color']">
                              {{ item.status_text['icon'] }}
                            </v-icon>
                            {{ item.status_text['text'] }}

                            <v-icon right small color="red" v-if="item.status === 'refused'">
                              mdi-arrow-right
                            </v-icon>

                          </v-chip>
                        </td>

                        <td class="text-no-wrap">
                          <!-- {{ item.user?.name }} -->
                            <Avatar :user="item.user" />
                        </td>

                        <td class="text-no-wrap">
                          {{ item.user?.phone }}
                        </td>

                        <td class="text-no-wrap font-weight-bold text-center">
                          {{ item.total_validated }}
                        </td>

                        <td class="text-no-wrap gifty-text font-weight-bold text-center">
                          {{ item.total_winning_points }}
                        </td>

                        <td class="text-no-wrap">
                          {{ formatDate(item.created_at) }}
                        </td>

                        <td class="text-no-wrap">
                          {{ item.receipt_date }}
                        </td>

                        <td class="text-no-wrap gifty-text font-weight-medium">
                          {{ item.receipt_reference }}
                        </td>

                        <td class="text-no-wrap gifty-text font-weight-medium">
                          {{ item.receipt_total }}
                        </td>

                        <td class="text-no-wrap">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-bind="attrs"
                                     @click="[detail = item , detailDialog = true]"
                                     v-on="on" color="gifty" icon>
                                <v-icon>mdi-eye-plus</v-icon>
                              </v-btn>
                            </template>
                            <span>Détails</span>
                          </v-tooltip>

                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-bind="attrs"
                                     @click="[ia = item.ai_response , iaDialog = true]"
                                     v-on="on" color="gifty" icon>
                                <v-icon>mdi-robot-outline</v-icon>
                              </v-btn>
                            </template>
                            <span>Réponses IA</span>
                          </v-tooltip>

                        </td>

                      </tr>
                      </tbody>
                    </template>
                  </v-simple-table>

                  <div v-else>
                    <NoResults @reload="getInvestigations"/>
                  </div>
                </v-card-text>

                <v-divider/>

                <v-card-actions>

                  <div :style="{width: '120px'}">
                    <v-select v-model="perPage"
                              :items="[10,20,30,50,100]"
                              dense
                              hide-details
                              label="Ligne par page"
                              outlined></v-select>
                  </div>

                  <v-spacer/>

                  <v-pagination v-model="pagination.current"
                                :length="pagination.total"
                                circle
                                total-visible="8"
                                @input="getInvestigations"></v-pagination>

                </v-card-actions>

              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>


      <v-dialog v-model="iaDialog"
                max-width="500"
                persistent>
        <v-card>

          <v-card-title>
            Réponse IA
            <v-spacer/>
            <v-icon @click="iaDialog = false">mdi-close</v-icon>
          </v-card-title>
          <v-divider/>
          <v-card-text class="pa-8">
            <div class="pa-4 grey lighten-4">
              {{ ia }}
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="detailDialog"
                max-width="900"
                persistent>
        <v-card>

          <v-card-title>
            Détails
            <v-spacer/>
            <v-icon @click="detailDialog = false">mdi-close</v-icon>
          </v-card-title>
          <v-divider/>
          <v-card-text class="pa-8">
            <div v-if="detail.submissions?.length">
              <v-simple-table class="table-border rounded-lg">
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th>Enquête</th>
                    <th>Texte comparatif IA</th>
                    <th>Points</th>
                    <th>Statut</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(item,i) in detail.submissions"
                      :key="i"
                  >
                    <td>
                      {{ item.investigation?.name['fr'] }}
                    </td>
                    <td>
                      <div class="pa-2 rounded-lg my-3 grey lighten-4">
                        {{ item.investigation?.tasks[0]?.raw_text }}
                      </div>
                    </td>
                    <td class="font-weight-bold gifty-text">
                      {{ item.investigation?.winning_points }}
                    </td>
                    <td>
                      <v-chip small
                              :text-color="item.status_text['text_color']"
                              :class="item.status_text['class']"
                              class="font-weight-medium">
                        <v-icon left small :color="item.status_text['text_color']">
                          {{ item.status_text['icon'] }}
                        </v-icon>
                        {{ item.status_text['text'] }}
                      </v-chip>
                    </td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>

            <div class="pa-4 grey lighten-4" v-if="!detail.submissions?.length">
              Veuillez vérifier plus tard, aucune submission disponible.
            </div>

          </v-card-text>
        </v-card>
      </v-dialog>

    </v-container>

    <vue-easy-lightbox escDisabled
                       moveDisabled
                       :visible="visible"
                       :imgs="lightboxImage"
                       :index="index"
                       @hide="visible = false"></vue-easy-lightbox>

    <v-dialog v-model="rejectionReasonDialog" width="400">
      <v-card>
        <v-card-title>
          Motif de refus
          <v-spacer/>
          <v-icon @click="rejectionReasonDialog = false">mdi-close</v-icon>
        </v-card-title>
        <v-divider/>
        <v-card-text class="pa-8">
          {{ rejectionReason }}
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog width="400"
              persistent
              v-model="exportDialog">
      <v-card>

        <v-card-title v-if="showBtnDownload">
          <v-spacer/>
          <v-icon class="fade-in" color="red" @click="exportDialog = false">mdi-close</v-icon>
        </v-card-title>

        <v-card-text class="pa-8">

          <p class="d-flex align-center justify-space-between">
                <span v-if="!showBtnDownload">
                   Traitement de fichier en cours...
                </span>
            <span v-else>
                  Le fichier est prêt à être téléchargé.
                </span>
            <v-progress-circular indeterminate
                                 v-if="!showBtnDownload"
                                 size="20"
                                 width="3"
                                 color="gifty"></v-progress-circular>
          </p>

          <v-progress-linear height="12"
                             rounded
                             striped
                             :value="progression"
                             color="gifty"></v-progress-linear>

          <div class="d-flex align-center justify-space-between mt-3">
            <div class="gifty-text font-weight-medium">
              {{ progression }} %
            </div>
            <div>
              Total : {{ processed }} / {{ total_sales }}
            </div>
          </div>

          <div class="text-center mt-5">
            <v-btn :href="FILE_URL +'/uploads/'+ fileName"
                   target="_blank"
                   color="gifty"
                   class="fade-in"
                   dark
                   depressed
                   v-if="showBtnDownload">
              <v-icon left>mdi-download</v-icon>
              TÉLÉCHARGER
            </v-btn>
          </div>


        </v-card-text>
      </v-card>
    </v-dialog>


  </div>
</template>

<script>
import {HTTP} from "@/http-common";
import NoResults from "@/components/NoResults";
import Avatar from "@/components/Avatar";

export default {
  components: {Avatar ,NoResults},
  data() {
    return {
      keyword: '',
      overlay: false,
      iaDialog: false,
      rejectionReasonDialog: false,
      rejectionReason: null,
      ia: null,
      detail: {},
      detailDialog: false,
      isLoading: false,
      campaigns: [],
      investigations: [],
      total: 0,
      perPage: 10,
      pagination: {
        current: 1,
        total: 0
      },

      /**Lightbox**/
      FILE_URL: process.env.VUE_APP_FILE_URL,
      lightboxImage: "",
      visible: false,
      index: 0,

      /***export**/
      showBtnDownload: false,
      exportDialog: false,
      progressInterval: null,
      processed: 0,
      progression: 0,
      total_sales: 0,
      fileName: null,
    }
  },
  methods: {
handleExport() {
  this.processed = 0
  this.progression = 0
  this.total_sales = 0
  this.showBtnDownload = false
  this.overlay = true

  HTTP.post("/v1/opus/receipts/export").then((res) => {
    this.overlay = false
    this.fileName = res.data.data.file      // was res.data.data
    this.exportDialog = true
    this.fetchProgress()
  }).catch(err => {
    this.overlay = false
    this.$errorMessage = err.response?.status === 409
        ? "Un export est déjà en cours."
        : "Une erreur s'est produite."
    console.log(err)
  })
},
fetchProgress() {
  clearInterval(this.progressInterval)
  this.progressInterval = setInterval(() => {
    HTTP.get("/v1/opus/receipts/export-progress").then(res => {
      const p = res.data
      this.processed   = p.processed ?? 0
      this.total_sales = p.total ?? 0
      this.progression = p.percentage ?? 0

      const failed = p.status === 'failed'
      const done   = p.status === 'finished'
                  || (p.total > 0 && p.processed >= p.total)

      if (failed) {
        clearInterval(this.progressInterval)
        this.exportDialog = false
        this.$errorMessage = "L'export a échoué : " + (p.error || '')
        return
      }

      if (done) {
        clearInterval(this.progressInterval)
        this.progression = 100
        if (p.file) this.fileName = p.file
        this.showBtnDownload = true
      }
    }).catch(err => console.error('Error fetching progress:', err))
  }, 2000)
},
    getInvestigations(overlay = false) {

      if (overlay) {
        this.overlay = true
      } else {
        this.isLoading = true
      }

      HTTP.get('/v1/opus/receipts?page=' + this.pagination.current, {
        params: {
          perPage: this.perPage,
          keyword: this.keyword,
          status: this.status,
        }
      }).then(res => {
        this.pagination.current = res.data.current_page;
        this.pagination.total = res.data.last_page;
        this.total = res.data.total;
        this.investigations = res.data.data
        this.isLoading = false
        this.overlay = false
      }).catch(err => {
        this.isLoading = false
        this.overlay = false
        console.log(err)
      })
    },
    getCampaigns() {
      HTTP.get('/v1/opus/campaigns/all').then(res => {
        this.campaigns = res.data.data
      }).catch(err => {
        console.log(err)
      })
    },
  }
  ,
  created() {
    this.getInvestigations();
    this.getCampaigns();
  }
  ,
  watch: {
    perPage() {
      this.pagination.current = 1
      this.getInvestigations();
    }
    ,
    keyword() {
      this.getInvestigations();
    }
    ,
  }
}
;
</script>

<style scoped>
.cursor-zomm-in {
  cursor: zoom-in;
}

.bg-subtle-warning {
  background: rgba(255, 171, 2, 0.15) !important;
}

.bg-subtle-success {
  background: rgba(121, 215, 15, 0.15) !important;
}

.bg-subtle-error {
  background: rgba(255, 36, 66, 0.15) !important;
}

.bg-subtle-info {
  background: rgba(33, 150, 243, 0.15) !important;
}

.checked-card {
  background-color: rgba(51, 51, 51, 0.08);
}
</style>
